module.exports = __webpack_public_path__ + "media/images/emblems/Finhaut.wappen-701b0bfd5fa22d46506eee9a54bb0973.png";